import { ref } from 'vue';
import { getConfigValue } from '@/core/consts/config';

const isInit = ref(false);
const isLoading = ref(false);

export const useYandexMetrika = () => {
  const init = async () => {
    if (isInit.value || isLoading.value) return;

    if (!getConfigValue('yandexMetrikaEnabled')) {
      console.info('Yandex Metrika is disabled in config!');
      return;
    }

    const metrikaId = getConfigValue('yandexMetrikaId');
    if (!metrikaId) {
      console.error('Yandex Metrika ID is not set');
      return;
    }

    isLoading.value = true;

    (function(m: any, e: any, t: any, r: any, i: any, k?: any, a?: any) {
      m[i] = m[i] || function() {
        (m[i].a = m[i].a || []).push(arguments);
      };
      m[i].l = 1 * Number(new Date());
      
      for (let j = 0; j < document.scripts.length; j++) {
        if (document.scripts[j].src === r) {
          return;
        }
      }
      
      k = e.createElement(t);
      a = e.getElementsByTagName(t)[0];
      k.async = 1;
      k.src = r;
      a.parentNode.insertBefore(k, a);
    })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');

    (window as any).ym(Number(metrikaId), 'init', {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: true
    });

    const noscript = document.createElement('noscript');
    const div = document.createElement('div');
    const img = document.createElement('img');
    img.src = `https://mc.yandex.ru/watch/${metrikaId}`;
    img.style.position = 'absolute';
    img.style.left = '-9999px';
    img.alt = '';
    div.appendChild(img);
    noscript.appendChild(div);
    document.body.appendChild(noscript);

    isInit.value = true;
    isLoading.value = false;
    
    console.info('Yandex Metrika initialized with ID:', metrikaId);
  };

  return {
    init,
    isInit,
    isLoading,
  };
};
